"use strict";

class SuperErrorLogController {

    constructor($scope, $window, $filter, SSAppService, SSHttpService, SSUtilService, SSDateService, SSAlertService, $timeout, SSConfigService, SSConfirmationService, SSUserService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.SSAppService = SSAppService;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAlertService = SSAlertService;
        self.$timeout = $timeout;
        self.SSUserService = SSUserService;
        self.SSConfigService = SSConfigService;
        self.SSConfirmationService = SSConfirmationService;
        self.data = SHOWSUITE.data;
        self.filter = $filter;
        self.nationalities = self.SSConfigService.getNationalities();
        self.countries = self.SSConfigService.getCountries();

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;
        self.filter = {
            fromDate: moment().format('DD/MM/YYYY 00:00:00'),
        };
        self.pagination = {
            current: 1
        };

        self.pageChanged = function (newPage) {
            self.getLogs(newPage);
        };

        // WEB-4851: numeric options (ng-options) so the numeric model selects its option.
        self.LIMITS = [10, 20, 50, 100, 500, 1000];
        self.limit = 10;
        self.offset = 0;

        self.getLogs(self.current);

    }

    previousPage() {
        const self = this;

        self.offset = self.offset - parseInt(self.limit);
        self.getLogs();
    }

    nextPage() {
        const self = this;

        self.offset = self.offset + parseInt(self.limit);
        self.getLogs();
    }

    isJson(item) {
        item = typeof item !== "string"
            ? JSON.stringify(item)
            : item;

        try {
            item = JSON.parse(item);
        } catch (e) {
            return false;
        }

        if (typeof item === "object" && item !== null) {
            return true;
        }

        return false;
    }

    detailView(error_log) {
        const self = this;
        if (!error_log)
            return;

        self.current_error_log = error_log;
        self.detail_view_enable = self.detail_view_enable ? false : true;
    }

    /**
     * Fetches one page of API Logs for the current filters.
     *
     * @param {number} [page] Page to load; omitted keeps the current offset.
     * @remarks WEB-4851: From / To go to the API to the second (see dateFormatServer()).
     *          The records dropdown is the only source of the limit — the sessionStorage
     *          "limit_filter" left by the DMS sales application page no longer overrides it.
     */
    getLogs(page) {
        const self = this;

        let fromDate = self.dateFormatServer(self.filter.fromDate);
        let toDate = self.dateFormatServer(self.filter.toDate);
        if (fromDate === null || toDate === null) {
            self.SSAlertService.danger('Invalid date', 'Enter From / To as DD/MM/YYYY HH:mm:ss, or pick it from the calendar.');
            return;
        }

        if (page) {
            self.current = page;
            self.offset = (page * self.limit) - self.limit;
        }

        let url = 'sec/super/error-log';
        let params = {
            'limit': self.limit,
            'offset': self.offset,
            'send_total_count': true,
            'message': self.filter.searchMessage,
            'request_url': self.filter.searchRequesturl,
            'from_date': fromDate,
            'to_date': toDate,
            'user_id': self.filter.userId,
            'request_method': (self.filter.request_method === 'ALL' ? '' : self.filter.request_method),
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.error_logs = response.data.error_logs;
            jQuery.each(self.error_logs, function (i, error_log) {
                error_log.params = JSON.parse(error_log.params);
                if (error_log.params.order) {
                    error_log.params.order = JSON.parse(error_log.params.order);
                }
                error_log.params = JSON.stringify(error_log.params, undefined, 2);
                error_log.headers = JSON.stringify(JSON.parse(error_log.headers), undefined, 2);
                error_log.stack_trace = JSON.parse(error_log.stack_trace);
            });

            self.error_logs_total = response.data.total_count;
        });
    }

    /**
     * WEB-4851 - Converts a From / To filter value (DD/MM/YYYY HH:mm:ss as the picker writes it;
     * HH:mm or a bare date are accepted when typed) to the API's format. A bare date is sent
     * date-only so the API applies whole-day bounds.
     *
     * @param {string} dateTime UI filter value.
     * @returns {string|undefined|null} YYYY-MM-DD HH:mm:ss / YYYY-MM-DD; undefined when empty
     *          (no filter); null when it cannot be parsed.
     */
    dateFormatServer(dateTime) {
        if (!dateTime || !String(dateTime).trim()) {
            return;
        }

        dateTime = String(dateTime).trim();
        let hasTime = /\d{1,2}:\d{2}/.test(dateTime);
        let date = moment(dateTime, hasTime ? ['D/M/YYYY H:m:s', 'D/M/YYYY H:m'] : 'D/M/YYYY', true);
        if (!date.isValid()) {
            return null;
        }

        return date.format(hasTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD');
    }

    dateFormatUI(dateTime) {
        if (dateTime) {
            return moment(dateTime, 'YYYY-MM-DD HH:mm:ss')
                .format('DD/MM/YYYY HH:mm');
        }
    }

}

SuperErrorLogController.$inject = ['$scope', '$window', '$filter', 'SSAppService', 'SSHttpService', 'SSUtilService', 'SSDateService', 'SSAlertService', '$timeout', 'SSConfigService', 'SSConfirmationService', 'SSUserService'];
app.controller('SuperErrorLogController', SuperErrorLogController);

/**
 * WEB-4851 - jQuery-UI date + time picker (hour / minute / second) for the From / To filters.
 * Use as datepicker="start" or datepicker="end"; the "end" picker opens at 23:59:59 so picking
 * just a day still covers that whole day.
 */
app.directive("datepicker", function () {
    function link(scope, element, attrs) {
        let isEnd = attrs.datepicker === 'end';

        element.datetimepicker({
            dateFormat: "dd/mm/yy",
            timeFormat: "HH:mm:ss",
            changeMonth: true,
            changeYear: true,
            controlType: "select",
            oneLine: true,
            showSecond: true,
            hour: isEnd ? 23 : 0,
            minute: isEnd ? 59 : 0,
            second: isEnd ? 59 : 0,
        });
    }

    return {
        require: 'ngModel',
        link: link
    };
});